/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useRef } from "react";

// react-router-dom components
import { Link } from "react-router-dom";


import UtentiService from "services/API/Utenti/UtentiService";

// @mui material components
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import ReactHookFormCheckBox from "common/components/mycomponents/ReactHookFormCheckBox"
import Alert from '@mui/material/Alert';


// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";
import MDInput from "common/components/MD/MDInput";
import MDButton from "common/components/MD/MDButton";


// Authentication layout components piu largo
import SignupLayout from "layouts/SignupLayout";

// Images
import bgImage from "common/assets/images/bg-sign-in-basic.png";

import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

//validazione lato client
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { brandFabSx } from "common/assets/theme/components/brandButtonSx";
import brandButtonSx from "common/assets/theme/components/brandButtonSx";
import { brandButtonOutlinedSx } from "common/assets/theme/components/brandButtonSx";
import { brandAnnullaButtonSx } from "common/assets/theme/components/brandButtonSx";
import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup } from "@mui/material";



function ExpoRegister() {

  const validationSchema = Yup.object().shape({

    nome: Yup.string().required('Nome e Cognome richiesti').max(50, 'Lunghezza massima raggiunta'),
    cognome: Yup.string().required('Nome e Cognome richiesti').max(50, 'Lunghezza massima raggiunta'),
    email: Yup.string()
      .required('Email richiesta')
      .email('Email non valida'),
    ragione_sociale: Yup.string()
      .required('Ragione Sociale richiesto')
      .max(100, 'Lunghezza massima raggiunta'),
    telefono: Yup.string()
      .required('Telefono richiesto')
      .max(20, 'Lunghezza massima raggiunta'),

    password: Yup.string()
      .required('Password is required')
      .min(6, 'Password must be at least 6 characters')
      .max(40, 'Password must not exceed 40 characters'),
    confirmPassword: Yup.string()
      .required('Confirm Password is required')
      .oneOf([Yup.ref('password'), null], 'Confirm Password does not match'),


    /*  privacy: Yup.boolean().required('Privacy richiesto').test('is true',
        'Il consenso privacy è richiesto.',
        (value) => value ===true),*/
    privacy: Yup.bool().oneOf([true], "Devi dichiarare di aver preso visione dell'informativa"),
    consenso_d: Yup.string().oneOf(["SI", "NO"], "Indica la tua scelta"),
    consenso_e: Yup.string().oneOf(["SI", "NO"], "Indica la tua scelta"),
    consenso_f: Yup.string().oneOf(["SI", "NO"], "Indica la tua scelta"),
    consenso_g: Yup.string().oneOf(["SI", "NO"], "Indica la tua scelta"),
    consenso_h: Yup.string().oneOf(["SI", "NO"], "Indica la tua scelta"),
  });

  const {
    register, //register inputs
    reset, setValue, control,
    handleSubmit,//handle form submit
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);


  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const richiedi_credenziali = async (formData) => {

    setError(null);

    var data = {
      nome: formData.nome.trim(),
      cognome: formData.cognome.trim(),
      ragione_sociale: formData.ragione_sociale.trim(),
      email: formData.email.trim().toLowerCase(),
      username: formData.email.trim().toLowerCase(),
      telefono: formData.telefono.trim(),
      password: formData.password,
      privacy: formData.privacy,
      consenso_d: formData.consenso_d,
      consenso_e: formData.consenso_e,
      consenso_f: formData.consenso_f,
      consenso_g: formData.consenso_g,
      consenso_h: formData.consenso_h,
    };


    try {

      //console.log(data);

      const response = await UtentiService.createExpo(data);
      handleResponse(response);
    } catch (errore) {
      handleError(errore);
    } finally {
      handleTop();
    }

  };

  function handleResponse(response) {

    console.log(response.data);
    setSubmitted(true);
    reset({
      nome: '',
      cognome: '',
      ragione_sociale: '',
      telefono: '',
      email: '',
      password: '',
      confirmPassword: '',
      privacy: false,
    });

  }

  function handleError(error) {
    setError(error);
    console.log("ERRORE" + error);
    console.log(error.code);

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log("ERROR:RESPONSE" + error.response.data);
      setErrorMessage(error.response.data);

    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log("EEROR:REQUEST" + error.request);
      setErrorMessage(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      setErrorMessage(error.message);
    }

  }
  const myref = useRef();

  const [pos, setPos] = useState(false);

  const handleTop = () => {
    myref.current.scrollTop = 0;
    myref.current.focus();
    setPos(false);
  };

  const handleScroll = () => {

    if (myref.current.scrollTop > 50) {
      if (!pos) setPos(true);
    } else {
      if (pos) setPos(false);
    }
  };

  useEffect(() => {
    const temp = myref.current;
    if (temp != null) {
      temp.addEventListener("scroll", handleScroll);
      return () => temp.removeEventListener("scroll", handleScroll);
    }
  });

  const INFORMATIVA_URL = "https://far.umbriafiere.it/download/Informativa_Espositori.html";

  const CONSENSI = [
    {
      name: "consenso_d",
      lettera: "D",
      titolo: "Pubblicazione",
      testo:
        "Acconsento alla pubblicazione dei dati miei e dell'azienda sul catalogo ufficiale, sul sito web, sulla pianta guida, su comunicati stampa e su comunicazioni e promo mail relative alla Manifestazione.",
    },
    {
      name: "consenso_e",
      lettera: "E",
      titolo: "Statistiche e ricerche di mercato",
      testo: "Acconsento all'elaborazione dei miei dati per studi e ricerche statistiche e di mercato.",
    },
    {
      name: "consenso_f",
      lettera: "F",
      titolo: "Eventi e incontri promozionali",
      testo:
        "Acconsento a ricevere inviti e a partecipare a eventi e incontri, anche di natura promozionale, organizzati da Umbriafiere SpA.",
    },
    {
      name: "consenso_g",
      lettera: "G",
      titolo: "Comunicazioni commerciali di Umbriafiere SpA",
      testo:
        "Acconsento a ricevere da Umbriafiere SpA comunicazioni informative, promozionali e commerciali, anche relative a edizioni successive della Manifestazione e ad altre iniziative del Titolare, tramite e-mail, SMS, telefono e posta.",
    },
    {
      name: "consenso_h",
      lettera: "H",
      titolo: "Comunicazione a partner commerciali",
      testo:
        "Acconsento alla comunicazione dei miei dati di contatto a partner commerciali di Umbriafiere SpA per invio di loro comunicazioni promozionali in qualità di autonomi titolari del trattamento.",
    },
  ];

  const linkPrivacySx = ({ palette: { brand } }) => ({
    color: brand.main,
    fontWeight: 700,
    textDecoration: "underline",
    textUnderlineOffset: "2px",
  });


  return (
    <SignupLayout image={bgImage} ref={myref} >
      <Card sx={{ mt: 10, mb: 15 }} >
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="brand"
          borderRadius="lg"
          coloredShadow="brand"
          align="center"
        >

          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            FARFIERA
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
          </Grid>
        </MDBox>

        <MDBox pt={1} pb={3} px={3} component="form" role="form">


          <CardContent>
            <MDBox>
              <MDBox opacity={1} textAlign="center">
                <MDTypography variant="h5" fontWeight="medium" sx={{
                  color: "#388e3c"
                }} mt={1} mb={2} >
                  Registrazione Azienda
                </MDTypography>
              </MDBox>
              {((submitted) || (error !== null)) &&
                <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center" ref={myref} mb={4}>

                  {(submitted) &&
                    <MDBox textAlign="center">
                      <Alert severity="success">Dati salvati con successo! Ti è stata inviata una email per attivare l'account!</Alert>
                    </MDBox>
                  }
                  {error !== null &&
                    <MDBox textAlign="center">
                      <Alert color="error"><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>
                    </MDBox>
                  }
                </MDBox>
              }
              {(!submitted) &&
                <MDBox>
                  <MDBox opacity={1} textAlign="center" mb={4}>
                    <MDTypography variant="button" sx={{
                    }} mt={1}  >
                      Il seguente modulo ti permetterà di richiedere le credenziali per entrare nell'Area Riservata e poter compilare la Proposta di Partecipazione
                    </MDTypography>
                  </MDBox>


                  <MDBox mb={2}>
                    <MDInput type="text" label="Ragione Sociale" name='ragione_sociale' {...register('ragione_sociale')} required fullWidth
                      error={errors.ragione_sociale ? true : false} InputLabelProps={{ shrink: true }} />

                  </MDBox>

                  <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr' }}>
                    <MDBox>
                      <MDInput type="text" label="Cognome Referente" name='cognome' fullWidth required {...register('cognome')}
                        error={errors.cognome ? true : false} InputLabelProps={{ shrink: true }}
                      />
                      {errors.cognome ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.cognome?.message}</span> : ''}
                    </MDBox>
                    <MDBox>
                      <MDInput type="text" label="Nome Referente" name='nome' fullWidth required {...register('nome')}
                        error={errors.nome ? true : false} InputLabelProps={{ shrink: true }}
                      />
                      {errors.nome ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.nome?.message}</span> : ''}
                    </MDBox>
                  </MDBox>


                  <MDBox mb={2}>

                    <MDInput type="text" label="Telefono" fullWidth required name='telefono' {...register('telefono')} InputLabelProps={{ shrink: true }} error={errors.telefono ? true : false} />
                    {errors.telefono ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.telefono?.message}</span> : ''}
                  </MDBox>
                  <MDBox mb={2} >
                    <MDInput type="text" label="Email(Username)" fullWidth required name='email' {...register('email')} error={errors.email ? true : false} InputLabelProps={{ shrink: true }} />
                    {errors.email ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.email?.message}</span> : ''}
                  </MDBox>


                  <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '1fr 1fr' }}>
                    <MDBox>
                      <MDInput type="password" label="Password" fullWidth id="password" required
                        name="password" {...register('password')} InputLabelProps={{ shrink: true }} />
                      {
                        errors.password ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.password?.message}</span> : ''
                      }
                    </MDBox>
                    <MDBox>
                      <MDInput type="password" label="Conferma Password" fullWidth {...register('confirmPassword')} name="confirmPassword" InputLabelProps={{ shrink: true }} />
                      {
                        errors.confirmPassword ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.confirmPassword?.message}</span> : ''
                      }
                    </MDBox>
                  </MDBox>




                  {/* Informativa obbligatoria */}
                  <MDBox mt={3} mb={1}>
                    <ReactHookFormCheckBox
                      name="privacy"
                      control={control}
                      label={
                        <MDTypography variant="button" fontWeight="regular" color="text" sx={{ userSelect: "none" }}>
                          Dichiaro di aver preso visione dell'
                          <MDBox
                            component="a"
                            href={INFORMATIVA_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={linkPrivacySx}
                          >
                            Informativa privacy Espositori
                          </MDBox>{" "}
                          relativa alla registrazione su FARFIERA e alla gestione della partecipazione alle
                          manifestazioni organizzate da Umbriafiere SpA
                        </MDTypography>
                      }
                    />
                    {errors.privacy && (
                      <MDTypography variant="caption" color="error" display="block" role="alert">
                        {errors.privacy.message}
                      </MDTypography>
                    )}
                  </MDBox>
                  {/* Consensi facoltativi */}
                  <MDBox
                    component="fieldset"
                    mt={3}
                    p={2}
                    borderRadius="lg"
                    sx={({ palette: { brand }, functions: { rgba } }) => ({
                      border: `1px solid ${rgba(brand.main, 0.25)}`,
                      backgroundColor: rgba(brand.focus, 0.05),
                    })}
                  >
                    <MDTypography
                      component="legend"
                      variant="h6"
                      px={1}
                      sx={({ palette: { brand } }) => ({ color: brand.main })}
                    >
                      Consensi facoltativi
                    </MDTypography>

                    <MDTypography variant="button" fontWeight="regular" color="text" display="block" mb={2}>
                      Nella sezione seguente puoi esprimere le tue preferenze facoltative. Puoi modificarle in
                      qualsiasi momento dalla sezione «Le mie preferenze privacy» del tuo profilo FARFIERA oppure
                      scrivendo a{" "}
                      <MDBox component="a" href="mailto:privacy@umbriafiere.it" sx={linkPrivacySx}>
                        privacy@umbriafiere.it
                      </MDBox>
                      . <strong>Il diniego non impedisce la registrazione né la partecipazione alla Manifestazione.</strong>
                    </MDTypography>

                    {CONSENSI.map((c, i) => (
                      <MDBox
                        key={c.name}
                        py={1.5}
                        sx={({ palette: { grey } }) => ({
                          borderTop: i === 0 ? "none" : `1px solid ${grey[300]}`,
                        })}
                      >
                        <Controller
                          name={c.name}
                          control={control}
                          defaultValue=""
                          render={({ field, fieldState }) => (
                            <FormControl error={!!fieldState.error} fullWidth>
                              <MDTypography id={`${c.name}-label`} variant="button" fontWeight="bold" display="block"
                                sx={({ palette: { brand } }) => ({ color: brand.main })}
                              >
                                {c.lettera} – {c.titolo}
                              </MDTypography>
                              <MDTypography id={`${c.name}-desc`} variant="button" fontWeight="regular" color="text" display="block">
                                {c.testo}
                              </MDTypography>

                              <RadioGroup
                                row
                                {...field}
                                aria-labelledby={`${c.name}-label`}
                                aria-describedby={`${c.name}-desc`}
                              >
                                <FormControlLabel value="SI" control={<Radio />} label="Acconsento" />
                                <FormControlLabel value="NO" control={<Radio />} label="Non acconsento" />
                              </RadioGroup>

                              {fieldState.error && (
                                <FormHelperText sx={{ ml: 0 }}>{fieldState.error.message}</FormHelperText>
                              )}
                            </FormControl>
                          )}
                        />
                      </MDBox>
                    ))}
                  </MDBox>

                  {/* Nota a piè di schermata */}
                  <MDTypography variant="caption" color="text" display="block" mt={2} sx={{ lineHeight: 1.5 }}>
                    Le scelte espresse in fase di registrazione sono registrate e conservate a fini di
                    accountability. Puoi revocare o modificare i consensi facoltativi in qualsiasi momento dalla
                    sezione «Le mie preferenze privacy» del tuo profilo oppure scrivendo a{" "}
                    <MDBox component="a" href="mailto:privacy@umbriafiere.it" sx={linkPrivacySx}>
                      privacy@umbriafiere.it
                    </MDBox>
                    . Per il trattamento dei tuoi dati necessario alla gestione contrattuale della partecipazione,
                    la base giuridica è l'esecuzione del contratto: per tali trattamenti non è richiesto il
                    consenso.
                  </MDTypography>
                  <MDBox>






                  </MDBox>

                </MDBox>
              }

            </MDBox>
          </CardContent>
          {(!submitted) &&
            <MDBox mt={4} mb={1}>
              <MDButton variant="outlined" sx={brandButtonOutlinedSx} fullWidth onClick={handleSubmit(richiedi_credenziali)} type="submit">
                Richiedi le credenziali
              </MDButton>
            </MDBox>}
          <MDBox mt={3} mb={1} textAlign="center">
            <MDButton
              component={Link}
              to="/login"
              variant="contained"
              aria-label={`Torna al login`}
              sx={brandAnnullaButtonSx}
            >Torna al login
            </MDButton>

          </MDBox>

        </MDBox>

      </Card>
    </SignupLayout>
  );
}

export default ExpoRegister;
